import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { withStateHandlers } from 'recompose';

import {
  Button,
  ButtonToolbar,
  Clearfix,
  Modal,
  FormGroup,
  ControlLabel,
  Form,
} from 'react-bootstrap';

import { tryHandleGraphQLError } from '../../../../utils/graphQLErrorHandlers';

export const approvePerDiemModalPropTypes = {
  openApproveModal: PropTypes.func.isRequired,
  closeApproveModal: PropTypes.func.isRequired,
  showApproveModal: PropTypes.bool.isRequired,
};


export const withApprovePerDiemModalState = withStateHandlers(
  (props) => { return { showApproveModal: false }; },
  {
    openApproveModal: (state, props) => {
      return () => { return { showApproveModal: true }; };
    },
    closeApproveModal: (state, props) => {
      return () => { return { showApproveModal: false }; };
    },
  },
);


const propTypes = exact({
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  approvePerDiemAction: PropTypes.func.isRequired,
});


export class ApprovePerDiemModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleApprovePerDiem = this.handleApprovePerDiem.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  async handleApprovePerDiem() {
    const { onHide, approvePerDiemAction } = this.props;
    try {
      await approvePerDiemAction();
      onHide();
    } catch (e) {
      const graphQLErrorMessage = tryHandleGraphQLError(e);
      this.setState({ errorMessage: graphQLErrorMessage });
    }
  }

  render() {
    const { show, onHide } = this.props;
    const { errorMessage } = this.state;
    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Approve Per Diem Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Clearfix>
            <Form>
              <FormGroup>
                <ControlLabel>Are You Sure You Want To Approve This Per Diem?</ControlLabel>
              </FormGroup>
              <ButtonToolbar className="pull-right">
                <Button
                  bsStyle="warning"
                  onClick={onHide}
                >
                  Cancel
                </Button>
                <Button
                  bsStyle="primary"
                  onClick={this.handleApprovePerDiem}
                >
                  Confirm
                </Button>
              </ButtonToolbar>
            </Form>
          </Clearfix>
          {errorMessage && <span className="form-error">{errorMessage}</span>}
        </Modal.Body>
      </Modal>
    );
  }
}

ApprovePerDiemModal.propTypes = propTypes;

export default ApprovePerDiemModal;
